
import apiConfig from "@/config/api.config"
import { appConfig } from "@/config/app.config"

/**
 * @func 获取商品库存
 * @param {*} product
 * @returns
 */
function getProductStock(product) {
    try {
        var branchStock = product.branch_stock
        // 没有branch_stock直接返回0
        if (!branchStock) {
            return 0
        }
        let branchId = appConfig.APP_BRANCH_ID
        return branchStock[branchId]
    } catch (error) {
        console.log(error)
    }
    return 0
}

/**
 * @func 重新整理商品价格
 */
function reArrangeProductPrice(product) {
    if (appConfig.APP_GLOBAL_DISCOUNT > 0) {
        product.retail = parseFloat(product.retail) * (1 - (appConfig.APP_GLOBAL_DISCOUNT / 100.0))
    }
    return product
}


export {
    getProductStock,
    reArrangeProductPrice
}
